import { render, staticRenderFns } from "./field-manage.vue?vue&type=template&id=5356de1c&scoped=true&"
import script from "./field-manage.vue?vue&type=script&lang=js&"
export * from "./field-manage.vue?vue&type=script&lang=js&"
import style0 from "./field-manage.vue?vue&type=style&index=0&id=5356de1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5356de1c",
  null
  
)

export default component.exports